import { Helmet } from "react-helmet-async";

const SITE = "https://quantumcover.co.nz";
const DEFAULT_IMG = `${SITE}/og-image.jpg`;

export const Seo = ({ title, description, path = "", image, jsonLd }) => {
  const url = `${SITE}${path}`;
  const ogImage = image ? (image.startsWith("http") ? image : `${SITE}${image}`) : DEFAULT_IMG;
  const ld = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Quantum Cover" />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {ld.map((obj, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(obj)}</script>
      ))}
    </Helmet>
  );
};

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE}${it.path}`,
  })),
});

export const faqLd = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const serviceLd = (name, description, path) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: name,
  name: `${name} | Quantum Cover`,
  description,
  provider: { "@type": "InsuranceAgency", name: "Quantum Cover", url: SITE },
  areaServed: { "@type": "Country", name: "New Zealand" },
  url: `${SITE}${path}`,
});

export const articleLd = (article, path) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: article.title,
  description: article.excerpt,
  author: { "@type": "Organization", name: "Quantum Cover" },
  publisher: { "@type": "Organization", name: "Quantum Cover", url: SITE },
  mainEntityOfPage: `${SITE}${path}`,
});
